import React from 'react';
import Row from './row'

export default class Container extends React.Component {

  render() {
    let editMode = this.props.mode == "edit"
    var rows = this.props.el.content || []
    if (Object.prototype.toString.call(rows) !== '[object Array]') rows = [];
    if (rows.length > 0) rows = rows.filter(el => el && el.type == "row")
    if (rows.length == 0) rows.push({type: "row"})
    this.props.el.content = rows
    
    let selected = editMode && this.props.root.state.selected == this
    var showRemove = false
    if (editMode && (rows.length > 0)) {
      for (var i = 0; i < rows.length; i++) {
        if (this.props.root.state.selectedEl == rows[i]) {
          showRemove = true;
          break;
        }
      }
    }
    return (
      <div 
        class={"news-grid news-container mode-"+this.props.mode+(selected ? " selected" : "")}
        onClick={editMode ? e => this.props.onSelect(e,this.props.el,this) : undefined}
      >
        {rows.map((el,e) => {
          return (
            <Row         
              key={e}
              index={e}
              el={el}
              mode={this.props.mode}
              root={this.props.root}
              onSelect={this.props.onSelect}
              iframes={this.props.iframes}
            />
          )
        })}
        {editMode &&
          <div class="row">
            <div class="col text-center p-2">
              <button class="btn btn-sm warning btn-grid" onClick={e => this.props.root.addRow(e, this.props.el, this)}>+</button>
              {showRemove && 
              <button class="btn btn-sm danger btn-grid ml-2" onClick={e => this.props.root.removeRow(e, this.props.el, this)}>-</button>
              }
            </div>
          </div>
        }
      </div>          
    )     
  }

}